import { combineReducers } from '@reduxjs/toolkit';

import { addressReducer, selectAddressReducer } from './address';
import { scheduleReducer } from './schedule';
import { tzReducer } from './timezone';

export { isBusyNow, isConfirmed } from './schedule';

export { TimezoneSelect, useTz } from './timezone';
export { useSchedules, useSchedule, schedulesApi } from './schedule';
export { useAddresses } from './address';

export { BusyIcon } from './schedule';

export const schedule = combineReducers({
	timezone: tzReducer,
	schedules: scheduleReducer,
	addresses: addressReducer,
	selectedAddress: selectAddressReducer,
});
